// extracted by mini-css-extract-plugin
module.exports = {"VideoPlayer":"VideoPlayer_VideoPlayer__8NEWl","VideoComments":"VideoPlayer_VideoComments__MzNN2","Comment":"VideoPlayer_Comment__20-1Q"};